module.exports = __webpack_public_path__ + "img/ac.de895001.svg";